import React, { Component } from 'react';
import { APP_CONST } from '../../../../constants';
import { GeckoFields, Spinner, GeckoBtn } from '../../../../components';
import ActivityTable from './components/ActivityTable';
import Queries from './Queries';

export class ModuleActivity extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            perPage: 10,
            nextPage: null,
            loading: false,
        }

        this.getActivity = this.getActivity.bind(this);
        this.loadMore = this.loadMore.bind(this);
    }

    componentDidMount() {
        this.loadMore();
    }

    getActivity(perPage = 10, nextPage = null) {
        this.setState({
            loading: true,
        });

        Queries.getActivity(perPage, nextPage)
        .then((response) => {
            this.setState({
                data: this.state.data.concat(response.events),
                nextPage: response.nextPage || null,
                loading: false,
            })
        }).catch((err) => {
            this.props.setAlert(err.message);
            
            this.setState({
                loading: false,
            });
        })
    }

    loadMore() {
        return this.getActivity(this.state.perPage, this.state.nextPage);
    }

    renderSpinner(loading = false) {
        if (!loading) return null;

        return (
            <div>
                <Spinner />
            </div>
        )
    }

    renderLoadMoreButton(nextPage = false, loading = false) {
        if (!nextPage || loading) return null;

        return (
            <div className="flex justify-center mt-4">
                <GeckoBtn
                    name="Load more"
                    type={APP_CONST.BTN_TYPE_OUTLINE}
                    size={APP_CONST.BTN_SIZE_SM}
                    handler={this.loadMore}
                />
            </div>
        )
    }

    renderTable(data) {
        return <ActivityTable data={data} />
    }

    render() {
        return (
            <div>
                {this.renderTable(this.state.data)}
                {this.renderSpinner(this.state.loading)}
                {this.renderLoadMoreButton(this.state.nextPage, this.state.loading)}
            </div>
        )
    }
}

ModuleActivity.defaultProps = {
    setAlert: () => null,
}

export default ModuleActivity;